export const THREADS_API_URL = '/gateway/api/assist/api/ai/v2/ai-feature/home/threads';

export const FEEDBACK_ENTRYPOINT = '535b44fe-5ac4-4d36-8c3a-46786abff5e0';

export const PROMPT_OVERRIDE_KEY = 'townsquare_threads_prompt_override';
